function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF"
}, React.createElement("path", {
  d: "M2.286 2.374L20 20.089l-2.285 2.285L0 4.66l2.286-2.286z"
}), React.createElement("path", {
  d: "M0 20.089L17.715 2.374 20 4.66 2.286 22.374 0 20.089z"
}));

var SvgCloseIcon = function SvgCloseIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 2.374 20 20"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMi4zNzQgMjAgMjAiPjxnIGZpbGw9IiNGRkYiPjxwYXRoIGQ9Ik0yLjI4NiAyLjM3NEwyMCAyMC4wODlsLTIuMjg1IDIuMjg1TDAgNC42NmwyLjI4Ni0yLjI4NnoiLz48cGF0aCBkPSJNMCAyMC4wODlMMTcuNzE1IDIuMzc0IDIwIDQuNjYgMi4yODYgMjIuMzc0IDAgMjAuMDg5eiIvPjwvZz48L3N2Zz4=";
export { SvgCloseIcon as ReactComponent };